import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const VAGARO_URL = "https://www.vagaro.com/itsnervani";
export const PARTNERS_FORM_URL = "https://forms.gle/RUBzYVr3XRYjT8dUA";
export const LOGO =
  "https://customer-assets-4nw71qhi.emergentagent.net/job_beauty-courses-pro/artifacts/2ser470r_LOGO3.webp";

export const api = axios.create({ baseURL: API });

export const openBooking = () =>
  window.open(VAGARO_URL, "_blank", "noopener,noreferrer");

export const openExternal = (url) =>
  window.open(url || VAGARO_URL, "_blank", "noopener,noreferrer");

export const openPartners = () => {
  if (PARTNERS_FORM_URL.startsWith("http")) {
    window.open(PARTNERS_FORM_URL, "_blank", "noopener,noreferrer");
  } else {
    window.location.href = PARTNERS_FORM_URL;
  }
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  {
    label: "Programs",
    to: "/programs",
    children: [
      { label: "All Programs", to: "/programs" },
      { label: "4 Days to Stateboard Success", to: "/course" },
      { label: "Nail Boss Blueprint AI Edition", to: "/blueprint" },
      { label: "Nail Boss Blueprint Workbook", to: "/blueprint" },
      { label: "Industries Served", to: "/industries" },
    ],
  },
  { label: "Services", to: "/services" },
  { label: "Shop", to: "/shop" },
  { label: "Partners", to: "/partners" },
  { label: "Contact", to: "/contact" },
];
